import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import CustomersTable from "../../../components/tables/CustomersTable.jsx";

export default function CustomerIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Kunden", path: "/admin/kunden" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Kundenverwaltung
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Übersicht aller Kunden
        </Typography>
      </Box>

      <CustomersTable
        onRowClick={(customer) => {
          if (!customer || !customer.id) {
            return;
          }
          navigate(`/admin/kunden/${customer.id}`);
        }}
      />
    </Box>
  );
}
